export default __webpack_public_path__ + "static/media/footerswirl.21bf0e3e.jpg";